import BasicContentHeadlineAndAbstract from './BasicContentHeadlineAndAbstract';

export default BasicContentHeadlineAndAbstract;
